import { useMutation } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useNavigate, useParams } from 'libs/router'
import { useToast, useAxiosPrivate } from 'shared/hooks'
import { FieldValues, UseFormSetError } from 'libs/form'

export const useChangePasswordMutation = (setError: UseFormSetError<FieldValues>) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const navigate = useNavigate()
	const params = useParams()

	const { mutate: changePasswordMutation, isPending: isChangePasswordLoading } = useMutation({
		mutationFn: (data) => {
			return axiosPrivate.post(`/accounts/${params.id}/change_password/`, data)
		},
		onSuccess: () => {
			useToast({ type: 'success', message: t('Password changed') })()

			navigate('/users')
		},
		onError: (res: any) => {
			if (res?.response?.data) {
				for (const [key, value] of Object.entries(res.response.data)) {
					setError(key, { message: value as string })
				}
			}

			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		changePasswordMutation,
		isChangePasswordLoading
	}
}
